export const humanNamePrefixOptionsOptionsList = [
  // { code: 'None', display: 'None' },
  { code: 'mr', display: 'Mr.' },
  { code: 'ms', display: 'Ms.' },
  { code: 'mrs', display: 'Mrs.' },
  { code: 'dr', display: 'Dr.' },
];
export const humanNameSuffixOptionsList = [
  // { code: 'None', display: 'None' },
  { code: 'jr', display: 'Jr' },
  { code: 'sr', display: 'Sr' },
  { code: 'I', display: 'I' },
  { code: 'II', display: 'II' },
  { code: 'III', display: 'III' },
];

export const patientGenderOptionsList = [
  { code: 'male', display: 'Male' },
  { code: 'female', display: 'Female' },
  { code: 'other', display: 'Other' },
  { code: 'unknown', display: 'Unknown' },
];

export const humanGenderOptionsList = [
  { code: 'male', display: 'Male' },
  { code: 'female', display: 'Female' },
  { code: 'other', display: 'Other' },
  { code: 'unknown', display: 'Unknown' },
];

export const usaStateListWithCodes = [
  {
    display: 'Alabama',
    code: 'AL',
    country: 'USA',
  },
  {
    display: 'Alaska',
    code: 'AK',
    country: 'USA',
  },
  {
    display: 'American Samoa',
    code: 'AS',
    country: 'USA',
  },
  {
    display: 'Arizona',
    code: 'AZ',
    country: 'USA',
  },
  {
    display: 'Arkansas',
    code: 'AR',
    country: 'USA',
  },
  {
    display: 'California',
    code: 'CA',
    country: 'USA',
  },
  {
    display: 'Colorado',
    code: 'CO',
    country: 'USA',
  },
  {
    display: 'Connecticut',
    code: 'CT',
    country: 'USA',
  },
  {
    display: 'Delaware',
    code: 'DE',
    country: 'USA',
  },
  {
    display: 'District Of Columbia',
    code: 'DC',
    country: 'USA',
  },
  {
    display: 'Federated States Of Micronesia',
    code: 'FM',
    country: 'USA',
  },
  {
    display: 'Florida',
    code: 'FL',
    country: 'USA',
  },
  {
    display: 'Georgia',
    code: 'GA',
    country: 'USA',
  },
  {
    display: 'Guam',
    code: 'GU',
    country: 'USA',
  },
  {
    display: 'Hawaii',
    code: 'HI',
    country: 'USA',
  },
  {
    display: 'Idaho',
    code: 'ID',
    country: 'USA',
  },
  {
    display: 'Illinois',
    code: 'IL',
    country: 'USA',
  },
  {
    display: 'Indiana',
    code: 'IN',
    country: 'USA',
  },
  {
    display: 'Iowa',
    code: 'IA',
    country: 'USA',
  },
  {
    display: 'Kansas',
    code: 'KS',
    country: 'USA',
  },
  {
    display: 'Kentucky',
    code: 'KY',
    country: 'USA',
  },
  {
    display: 'Louisiana',
    code: 'LA',
    country: 'USA',
  },
  {
    display: 'Maine',
    code: 'ME',
    country: 'USA',
  },
  {
    display: 'Marshall Islands',
    code: 'MH',
    country: 'USA',
  },
  {
    display: 'Maryland',
    code: 'MD',
    country: 'USA',
  },
  {
    display: 'Massachusetts',
    code: 'MA',
    country: 'USA',
  },
  {
    display: 'Michigan',
    code: 'MI',
    country: 'USA',
  },
  {
    display: 'Minnesota',
    code: 'MN',
    country: 'USA',
  },
  {
    display: 'Mississippi',
    code: 'MS',
    country: 'USA',
  },
  {
    display: 'Missouri',
    code: 'MO',
    country: 'USA',
  },
  {
    display: 'Montana',
    code: 'MT',
    country: 'USA',
  },
  {
    display: 'Nebraska',
    code: 'NE',
    country: 'USA',
  },
  {
    display: 'Nevada',
    code: 'NV',
    country: 'USA',
  },
  {
    display: 'New Hampshire',
    code: 'NH',
    country: 'USA',
  },
  {
    display: 'New Jersey',
    code: 'NJ',
    country: 'USA',
  },
  {
    display: 'New Mexico',
    code: 'NM',
    country: 'USA',
  },
  {
    display: 'New York',
    code: 'NY',
    country: 'USA',
  },
  {
    display: 'North Carolina',
    code: 'NC',
    country: 'USA',
  },
  {
    display: 'North Dakota',
    code: 'ND',
    country: 'USA',
  },
  {
    display: 'Northern Mariana Islands',
    code: 'MP',
    country: 'USA',
  },
  {
    display: 'Ohio',
    code: 'OH',
    country: 'USA',
  },
  {
    display: 'Oklahoma',
    code: 'OK',
    country: 'USA',
  },
  {
    display: 'Oregon',
    code: 'OR',
    country: 'USA',
  },
  {
    display: 'Palau',
    code: 'PW',
    country: 'USA',
  },
  {
    display: 'Pennsylvania',
    code: 'PA',
    country: 'USA',
  },
  {
    display: 'Puerto Rico',
    code: 'PR',
    country: 'USA',
  },
  {
    display: 'Rhode Island',
    code: 'RI',
    country: 'USA',
  },
  {
    display: 'South Carolina',
    code: 'SC',
    country: 'USA',
  },
  {
    display: 'South Dakota',
    code: 'SD',
    country: 'USA',
  },
  {
    display: 'Tennessee',
    code: 'TN',
    country: 'USA',
  },
  {
    display: 'Texas',
    code: 'TX',
    country: 'USA',
  },
  {
    display: 'Utah',
    code: 'UT',
    country: 'USA',
  },
  {
    display: 'Vermont',
    code: 'VT',
    country: 'USA',
  },
  {
    display: 'Virgin Islands',
    code: 'VI',
    country: 'USA',
  },
  {
    display: 'Virginia',
    code: 'VA',
    country: 'USA',
  },
  {
    display: 'Washington',
    code: 'WA',
    country: 'USA',
  },
  {
    display: 'West Virginia',
    code: 'WV',
    country: 'USA',
  },
  {
    display: 'Wisconsin',
    code: 'WI',
    country: 'USA',
  },
  {
    display: 'Wyoming',
    code: 'WY',
    country: 'USA',
  },
];
